/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_9Inputs */

const da_privacy_retention_9 = /** @type {(inputs: Privacy_Retention_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugsstatistik, fejl og svar på feedback hos PostHog: så længe de er nyttige til at forbedre tjenesten. Skriv til os, hvis du vil have dem slettet tidligere.`)
};

/** @type {(inputs: Privacy_Retention_9Inputs) => LocalizedString} */
const en_privacy_retention_9 = da_privacy_retention_9;

/**

* @param {Privacy_Retention_9Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_9 = /** @type {((inputs?: Privacy_Retention_9Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_9Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_9(inputs)
	return /** @type {LocalizedString} */ ("Brugsstatistik, fejl og svar på feedback hos PostHog: så længe de er nyttige til at forbedre tjenesten. Skriv til os, hvis du vil have dem slettet tidligere.")
});